module.exports = __webpack_public_path__ + "img/wallpaper-balance-your-meal.0fae9347.png";